import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmbedFormModule } from '@vuframe/vf-webviewer';

import { ShareCodeFormWrapperComponent } from './share-code-form.component';

const routes: Routes = [

    {
        path: '', component: ShareCodeFormWrapperComponent
    },
];

@NgModule({
    declarations: [ShareCodeFormWrapperComponent],
    imports: [
        CommonModule,
        EmbedFormModule,
        RouterModule.forChild(routes)
    ]
})
export class ShareCodeFormModule {
}
